import React, { useContext } from 'react';
import { AuthContext } from '../../../../App';
import { MARK_AS_READ_ICON_CLICK_EVENT, MARK_AS_UNREAD_ICON_CLICK_EVENT } from '../../../../utils/analytics/enums';
import { handleUpdateHubLog } from '../../../../utils/analytics/eventLogger';
import Notification from '../../../classes/Notification/Notification';
import Scrollbar from '../../scrollbar';
import EmptyNotificationContent from '../EmptyNotificationContent';
import NotificationsList from './NotificationsList';

interface NotificationsListProps {
  notifications: Notification[]
  // eslint-disable-next-line no-unused-vars
  onNotificationClick: (notification: Notification) => void
}

function Notifications({ notifications, onNotificationClick }: NotificationsListProps) {
  const { userId } = useContext(AuthContext);

  const onClick = (event: any, notification: Notification) => {
    if (isNotificationStatusIconClicked(event)) {
      updateNotificationReadStatus(notification);
      return;
    }
    onNotificationClick(notification);
  };

  const updateNotificationReadStatus = (notification: Notification) => {
    if (notification.read.isRead) {
      handleUpdateHubLog(userId, MARK_AS_UNREAD_ICON_CLICK_EVENT);
      notification.updateIsRead(false);
      return;
    }
    handleUpdateHubLog(userId, MARK_AS_READ_ICON_CLICK_EVENT);
    notification.updateIsRead(true);
  };

  const isNotificationStatusIconClicked = (event: any) => {
    if (
      event.target.parentElement.nodeName === 'svg'
      || event.target.parentElement.nodeName === 'path'
      || event.target.parentElement.nodeName === 'circle'
      || event.target.parentElement.classList.contains('unreadIcon')
      || event.target.parentElement.classList.contains('readIcon')
    ) { return true; }
    return false;
  };

  if (notifications.length === 0) {
    return <EmptyNotificationContent />;
  }

  const isUnreadNotificaitons = notifications.filter((not) => !not.read.isRead).length > 0;
  const MaxHeight = isUnreadNotificaitons ? '456px' : '476px';

  return (
    <Scrollbar maxHeight={MaxHeight}>
      <NotificationsList notifications={notifications} onClick={onClick} />
    </Scrollbar>
  );
}

export default Notifications;
